export default "__VITE_ASSET__CuZ90rcq__"